/**
 * Created by herbert on 2016-12-13.
 */

//function similar to jquery.load, but also replaces the element.
$.fn.loadWith = function (u, fn) {
	var c = $(this);
	$.get(u, function (d) {
		c.replaceWith(d);
		fn.call()
	});
};

function is_touch_device() {
	return (('ontouchstart' in window)
	|| (navigator.MaxTouchPoints > 0)
	|| (navigator.msMaxTouchPoints > 0));
}

/**
 * Copyright 2012, Digital Fusion
 * Licensed under the MIT license.
 * http://teamdf.com/jquery-plugins/license/
 *
 * @author Sam Sehnert
 * @desc A small plugin that checks whether elements are within
 *         the user visible viewport of a web browser.
 *         only accounts for vertical position, not horizontal.
 * KB MOD: Added support for viewPort padding and target offsets
 **/
$.fn.visible = function (partial, hidden, viewPortPadding, targetOffset) {

	var $t = $(this).eq(0),
		t = $t.get(0),
		$w = $(window),
		topPadding = viewPortPadding ? viewPortPadding.top ? viewPortPadding.top : 0 : 0,
		bottomPadding = viewPortPadding ? viewPortPadding.bottom ? viewPortPadding.bottom : 0 : 0,
		viewTop = $w.scrollTop() + topPadding,
		viewBottom = viewTop + $w.height() - topPadding - bottomPadding,
		targetOffsetTop = targetOffset ? targetOffset.top ? targetOffset.top : 0 : 0,
		targetOffsetBottom = targetOffset ? targetOffset.bottom ? targetOffset.bottom : 0 : 0,
		_top = $t.offset().top + targetOffsetTop,
		_bottom = _top + $t.height() - targetOffsetTop - targetOffsetBottom,
		compareTop = partial === true ? _bottom : _top,
		compareBottom = partial === true ? _top : _bottom,
		clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;
	//console.log('visible',!!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)),'bottom',compareBottom,viewBottom,(compareBottom <= viewBottom),'top',compareTop,viewTop,(compareTop >= viewTop))
	return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};
var theme = {}
theme.isScreen = function (screen) {
	//alert(screen+": "+$("#is-"+screen).is(":visible"));
	return $("#is" + screen).is(":visible");
}
theme.isXS = function () {
	return $("#isXS:visible").length;
};

theme.isSM = function () {
	return $("#isSM:visible").length;
};

theme.isMD = function () {
	return $("#isMD:visible").length;
};

theme.isLG = function () {
	return $("#isLG:visible").length;
};

theme.isXL = function () {
	return $("#isXL:visible").length;
};

theme.initMobileHeader = function () {
	$(".sm-btn-search__btn").on("click", function () {
		$("#site-search-holder .site-search, #page-head .sm-btn-search").toggleClass("show");

		if ($("#site-search-holder .site-search").hasClass("show")) {
			$(".site-search").find("input#SearchForm_dosearch_Search").focus();
			$("html").addClass("content-overlay");
		}else{
			$("html").removeClass("content-overlay");
		}
	});

	$(".sm-btn-menu__btn").on("click", function () {
		$("#navigation, #page-head .sm-btn-menu__btn").toggleClass("show");
		if ($("#navigation").hasClass("show")) {
			$("html").addClass("content-overlay");
		}else{
			$("html").removeClass("content-overlay");
		}

	});
	$(".btn-close-menu").on("click", function () {
		$("#navigation, #page-head .sm-btn-menu__btn").removeClass("show");
		$("html").removeClass("content-overlay");
	});
	$("html").on("click", function (e) {
		if (!$(e.target).closest("#navigation, #page-head .sm-btn-menu").length) {
			$("#navigation, #page-head .sm-btn-menu").removeClass("show");
		}
		if (!$(e.target).closest("#page-head .site-search, #page-head .sm-btn-search").length) {
			$("#site-search-holder .site-search, #page-head .sm-btn-search").removeClass("show");

		}
		if(
			!$(e.target).closest("#navigation, #page-head .sm-btn-menu").length &&
			!$(e.target).closest("#page-head .site-search, #page-head .sm-btn-search").length
		){
			$("html").removeClass("content-overlay");
		}

	});



};
/* Live search (find as you type) */
theme.initLiveSearch = function () {
	var searchAction = $("#SearchForm_dosearch").attr("action");
	var timerID = null;
	var cache = {};

	//$('#page-head .search').addClass('show-live-search');

	$('#SearchForm_dosearch_Search').keyup(function (e) {
		clearTimeout(timerID);
		var search = $(this);
		timerID = setTimeout(function () {
			doLiveSearch(search.val());
		}, 300);
	});


	function doLiveSearch(query) {
		if (query.length >= 2) {
			$('#page-head .site-search').addClass('searching');
			if (cache[query]) {
				updateResults(cache[query]);
				return;
			}
			$.get(searchAction, {Search: query})
				.done(function (data) {
					updateResults(data);
					if (!cache[query] && data && data.length > 0) {
						cache[query] = data;
					}
				});
		} else {
			$('#page-head .site-search').removeClass('show-live-search');
		}

	}

	function updateResults(data) {
		if (!$('#page-head .site-search').find('.live-search').length) {
			$('#page-head .site-search').append("<div class='live-search'></div>");
		}
		$('#page-head .live-search').replaceWith(data);
		//$('#page-head .live-search-content').attr("style", "max-height: " + parseInt($(window).height() - 140) + "px");
		$('#page-head .site-search').addClass('show-live-search').removeClass('searching');
	}


	$('#SearchForm_dosearch_Search').focus(function () {
		doLiveSearch($(this).val());
	});


	/**
	 * Hide search results when focus is lost.
	 */
	$("body").click(function (e) {
		var target = $(e.target);

		if (!target.is('#SearchForm_dosearch_Search'))
			$('#page-head .site-search').removeClass('show-live-search');

	});
	$("html").on("click", "#live-search-btn", function () {
		$("#SearchForm_dosearch").trigger("submit");
	});

};


theme.initNavigation = function () {
	$("#navigation").find("a[href='" + $("#navigation").data("rootpage") + "']").closest("li").addClass("section");
	if (theme.isXS() || theme.isSM()) {
		$(".nav-link--level-1").each(function () {
			var $item = $(this);
			$item.attr({
				"data-toggle": "collapse",
				"data-parent": "#navigation"
			});
		});
	} else {
		function addMega() {
			$(this).addClass("hovering");
		}

		function removeMega() {
			$(this).removeClass("hovering");
		}

		var megaConfig = {
			interval: 50,
			sensitivity: 10,
			over: addMega,
			timeout: 200,
			out: removeMega
		};
		if (is_touch_device()) {
			$("#navigation").find("ul.nav-areas>li.nav-item>a").on("click", function (event) {
				if (!$(this).parent().hasClass("hovering")) {// if already clicked once, go to that page
					$(this).closest("ul").children().removeClass("hovering");
					$(this).parent().addClass("hovering");
					$("body").on("touchstart.navigationHovering", function (event) {
						if (!$(event.target).closest("#navigation").length) {
							$("#navigation").find("ul.nav-areas>li").removeClass("hovering");
							$("body").off("touchstart.navigationHovering");
						}
					});
					return false;
				}
			});
		} else {
			//Add selected top-menu section, used because the navigation is cached
			$("#navigation").find("ul.nav-areas>li.nav-item").hoverIntent(megaConfig);
		}

	}

};
theme.initShowMoreButton = function () {
	/**
	 * Show more grid posts click handler.
	 * Related templates:
	 *  CardViewItem.ss
	 *  GridView_ViewFirst.ss
	 *  GridView_ViewMore.ss
	 */
	$('body').on('click', '[data-showmore]', function () {

		var $this = $(this)
			, $section = $this.closest('.itemlist')
			, paginationStart = $this.data('paginationstart')
			, showMoreURL = $this.data('showmore')
			, classType = $section.data('listclass')
			, type = $section.data('listtype')
			, filter = $section.data('listfilter') ? $section.data('listfilter') : ''
			, sort = $section.data('listsort') ? $section.data('listsort') : ''
			, search = $section.data('listsearch') ? $section.data('listsearch').replace(/ /g, '+') : ''
			, classMap = {

			'col-sm-6': 4, // In the case of '.col-sm-6', load four new items. It implies that 2x2x grid layout is used
			'col-sm-4': 6, // 2x3x, 3x3x -> load 6 items
			'col-sm-3': 8  // 3x4x, 4x4x -> load 8 items

		}
			, gridLayoutMap = {

			4: '2x2x',
			6: '3x3x',
			8: '4x4x'

		}
			, itemSize = $section.find('.grid-view-item,.card-view-item').last().attr('class').split(' ')[1]
			, itemsToLoad = $section.data("listitems")//classMap[itemSize]
			, gridLayout = gridLayoutMap[itemsToLoad]
			, relation = $section.data('listrelation') ? $section.data('listrelation') : ''

		// See Page.php::fetchItems for URL structure and what parameter does what.
			, URL = showMoreURL + '/' +
			paginationStart + '/' +
			itemsToLoad +
			'?Class=' + classType +
			'&Type=' + type +
			'&Filter=' + filter +
			'&Sort=' + sort +
			'&Relation=' + relation +
			'&GridLayout=' + gridLayout;

		if (filter == 'fetchSearchFilter')
			URL += '&Search=' + search;

		// Spinner icon, disable button.
		$this.addClass('active').attr('disabled', 'disabled');

		// Load the data from URL, and present the data.
		$this.closest('.row.view-more').loadWith(
			URL,
			function () {
				setTimeout(function () {
					$section.find('.fade-in:not(.in)').addClass('in');
				}, 50);
			}
		);

		return false;

	});
};
theme.initAjaxSliders = function (fromElem) {

	if ($(fromElem).length) {
		$(fromElem).each(function () {
			var royalSliderElem = $(this).find(".royalSlider");
			if ($(this).closest(".outdated-products").length){//$(this).find(".rsImg").length < 2) {
				$(this).addClass("royalslider-initialized");
				return true;
			}
			royalSliderElem.css({
				"height": royalSliderElem.find("img:first").height() + royalSliderElem.find(".rsNav img:first").height() + 20,
				"width": "100%"
			}).royalSlider({
				imageScaleMode: 'fit',
				keyboardNavEnabled: true,
				navigateByClick: false,
				controlsInside: false,
				video: {
					autoHideControlNav: true
				},
				autoScaleSliderWidth: 800,
				autoScaleSliderHeight: 800,
				autoScaleSlider: true,
				globalCaption: true,
				globalCaptionInside: true,

				fullscreen: {
					// fullscreen options go gere
					enabled: true,
					nativeFS: false
					//buttonFS:false
				},
				controlNavigation: royalSliderElem.find("img").length > 1 ? 'thumbnails' : "none",
				thumbs: {
					appendSpan: true,
					firstMargin: true,
					paddingBottom: 0,
					spacing: 4
				}
			});
			var royalSlider = royalSliderElem.data("royalSlider");
			if (royalSlider) {
				royalSlider.ev.on('rsSlideClick', function (event, originalEvent) {
					if (!this.isFullscreen) {
						this.enterFullscreen();
						event.preventDefault();
					}
				});

				royalSlider.ev.on('rsEnterFullscreen', function () {
					$("html").addClass("rsFullscreen")
				});
				royalSlider.ev.on('rsExitFullscreen', function () {
					$("html").removeClass("rsFullscreen");
				});
			}
			$(this).addClass("royalslider-initialized");
		});

		/*var slider=$(fromElem);
		 if(slider){
		 slider
		 }*/
	}
	//$(window).on("orientationchange",theme.initAjaxSliders(".product-images-slider"));

};
theme.initFixedProductHeaders = function () {

	var win = $(window);
	var reviewHeader = $('.review .main-column > header.panel');
	var allReviewedProducts = $("#reviewpage-main .product-list-item");
	var allHeaders = $('.fixed-product-header');
	var viewTopOffset = 0;
	var viewBottomOffset = $(window).height() * 2 / 3;

	win.scroll(function (event) {
		if (!(theme.isXS())) {
			return;
		}
		allReviewedProducts.each(function (i, el) {
			var container = $(el);
			viewTopOffset = container.find(".best-prices").height() + $(window).height();
			//container.find(".product-list-item__title").height() + container.find(".product-list-item__details").height();

			var fixedProductHeader = container.find('.fixed-product-header');
			if (container.visible(true, false, {
					top: viewTopOffset,
					bottom: viewBottomOffset
				}) && !reviewHeader.visible(true)) {
				allHeaders.removeClass("active");
				fixedProductHeader.addClass("active");
				return false;
			} else {
				fixedProductHeader.removeClass("active");
			}
		});

	});
};
theme.initReadMore = function () {
	if (theme.isXS() || theme.isSM()) {
		$("body").addClass("show-readmore-blocks").removeClass("hide-readmore-blocks");
		$(".readmore-block").each(function () {
			if ($(this).data("init") != true) {
				$(this).attr("data-init", "true").readmore({
					moreLink: '<button class="btn-lg btn-readmore">+ ' + $(this).data("readmore") + '</a>',
					lessLink: '<button class="btn-readmore btn-readmore--close">' + $(this).data("readless") + '</a>',
					beforeToggle: function (trigger, element, expanded) {
						element.toggleClass("readmore-reading")
					}
				});
			}
		});
	} else {
		$("body").removeClass("show-readmore-blocks").addClass("hide-readmore-blocks");
		/*$(".readmore-block").each(function () {
		 if (typeof $(this).readmore == 'function') {
		 console.log("remove readmore");
		 $(this).readmore('destroy');
		 }
		 });*/
	}
};
theme.initVouchers = function () {
	// Create Base64 Object
	var Base64 = {
		_keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) {
			var t = "";
			var n, r, i, s, o, u, a;
			var f = 0;
			e = Base64._utf8_encode(e);
			while (f < e.length) {
				n = e.charCodeAt(f++);
				r = e.charCodeAt(f++);
				i = e.charCodeAt(f++);
				s = n >> 2;
				o = (n & 3) << 4 | r >> 4;
				u = (r & 15) << 2 | i >> 6;
				a = i & 63;
				if (isNaN(r)) {
					u = a = 64
				} else if (isNaN(i)) {
					a = 64
				}
				t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
			}
			return t
		}, decode: function (e) {
			var t = "";
			var n, r, i;
			var s, o, u, a;
			var f = 0;
			e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
			while (f < e.length) {
				s = this._keyStr.indexOf(e.charAt(f++));
				o = this._keyStr.indexOf(e.charAt(f++));
				u = this._keyStr.indexOf(e.charAt(f++));
				a = this._keyStr.indexOf(e.charAt(f++));
				n = s << 2 | o >> 4;
				r = (o & 15) << 4 | u >> 2;
				i = (u & 3) << 6 | a;
				t = t + String.fromCharCode(n);
				if (u != 64) {
					t = t + String.fromCharCode(r)
				}
				if (a != 64) {
					t = t + String.fromCharCode(i)
				}
			}
			t = Base64._utf8_decode(t);
			return t
		}, _utf8_encode: function (e) {
			e = e.replace(/\r\n/g, "\n");
			var t = "";
			for (var n = 0; n < e.length; n++) {
				var r = e.charCodeAt(n);
				if (r < 128) {
					t += String.fromCharCode(r)
				} else if (r > 127 && r < 2048) {
					t += String.fromCharCode(r >> 6 | 192);
					t += String.fromCharCode(r & 63 | 128)
				} else {
					t += String.fromCharCode(r >> 12 | 224);
					t += String.fromCharCode(r >> 6 & 63 | 128);
					t += String.fromCharCode(r & 63 | 128)
				}
			}
			return t
		}, _utf8_decode: function (e) {
			var t = "";
			var n = 0;
			var r = c1 = c2 = 0;
			while (n < e.length) {
				r = e.charCodeAt(n);
				if (r < 128) {
					t += String.fromCharCode(r);
					n++
				} else if (r > 191 && r < 224) {
					c2 = e.charCodeAt(n + 1);
					t += String.fromCharCode((r & 31) << 6 | c2 & 63);
					n += 2
				} else {
					c2 = e.charCodeAt(n + 1);
					c3 = e.charCodeAt(n + 2);
					t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
					n += 3
				}
			}
			return t
		}
	}


	$('.voucher-modal').on('shown.bs.modal', function (event) {
		var elem = $(this).find(".voucher-code");
		if (elem.get(0)) {
			if (document.selection) {
				var range = document.body.createTextRange();
				range.moveToElementText(elem[0]);
				range.select();
			} else if (window.getSelection) {
				var range = document.createRange();
				range.selectNode(elem.get(0));
				window.getSelection().addRange(range);
			}
		}
	});
	$("html").on("click", "[data-trigger='voucher-modal']", function (e) {
		if (!$(this).hasClass("btn-primary")) {
			var $this = $(this);
			var row = $this.closest(".voucher-row");
			var target = $this.data("target");
			var storelink = $this.data("storelink");
			var trackinglink = $this.data("trackinglink");
			var toStoreTitle = $this.closest("section.vouchers").data("tostoretitle");
			$(target).modal().find(".voucher-code").text(Base64.decode($this.data("vouchercode")));

			window.open(trackinglink, '_blank');

			return false;
		} else {
			return false;
		}

	});

};
theme.initParallax = function () {

	setTimeout(function () {
		$(".parallax-image__img").each(function () {
			var parent = $(this).closest(".parallax-image");

			if ((theme.isSM() && parent.hasClass("primary-image")) || theme.isXS()) {
				var parentOrigHeight = $(this).closest(".parallax-image").height();
				parent.css({
					"height": $(this).height()
				});

				var fromWindowTop = parent.offset().top + parentOrigHeight;
				$(this).addClass("parallaxed");
				$(this).attr({
					"data-heightdiff": $(this).height() - parentOrigHeight,
					"data-fromtop": fromWindowTop
				});
			}else{
				$(this).removeClass("parallaxed").css("transform", "translateY(0)");
				parent.css("height","auto");
			}


		});

		theme.doParallax();
	}, 1);

};
theme.doParallax = function () {
	if (theme.isXS() || theme.isSM()) {
		$('.parallax-image__img.parallaxed').each(function () {
			var parent = $(this).closest(".parallax-image");

			var windowHeight = $(window).height();
			var objFromTop = $(this).data("fromtop");
			var fromWindowTop = objFromTop - $(window).scrollTop();
			var scrolled;
			if (objFromTop > windowHeight) {
				fromWindowTop = (-1 * fromWindowTop) > windowHeight ? windowHeight : (fromWindowTop < 0 ? 0 : fromWindowTop);
				scrolled = fromWindowTop * $(this).data("heightdiff") / windowHeight; //$(this).offset().top - $(window).scrollTop();
			} else {
				fromWindowTop = (-1 * fromWindowTop) > windowHeight ? windowHeight : (fromWindowTop < 0 ? 0 : fromWindowTop);
				scrolled = fromWindowTop * $(this).data("heightdiff") / objFromTop; //$(this).offset().top - $(window).scrollTop();
			}
			$(this).css('transform', 'translateY(-' + (scrolled) + 'px)');

		});
	}
};

// requires jquery viewport plugin and google GA
theme.initGAGoals = function () {
	if (typeof(ga) !== 'undefined') {
		var $links = jQuery(".best-price-link:visible");
		jQuery(window).scroll(function () {
			$links.filter(':in-viewport:not(.ga-logged)').each(function () {
				var $bestPriceID = jQuery(this).attr("data-bestpriceid");
				//GA-module helperscript

				/*jQuery(this).analyticsTrackEvent({
				 category: "BestPrice" ,
				 label: $bestPriceID ,
				 action: 'impression'
				 });*/
				if($bestPriceID){
					ga('send', 'event', 'BestPrice', 'impression', $bestPriceID, '1');
					console.log("impression " + $bestPriceID);
					jQuery(this).addClass("ga-logged");
				}
			});

		});
		jQuery(document).on("click", ".best-price-link", function () {
			var $bestPriceID = jQuery(this).attr("data-bestpriceid");
			ga('send', 'event', 'BestPrice', 'click', $bestPriceID, '1');
			console.log("click " + $bestPriceID);
		});
		jQuery(document).on("click", ".pricerunner-link", function () {
			var $bestPriceID = jQuery(this).attr("data-bestpriceid");
			ga('send', 'event', 'PricerunnerLink', 'click', window.location.pathname, '1');
			console.log("click " + window.location.pathname);
		});
	}
};

theme.initFramework = function(){
	//$('body *').on('touchstart', function (){});
	document.body.addEventListener('touchstart', function () {}, false);
	//document.body.addEventListener('mouseover', function () {}, false);

	jQuery("a[href^='admin/pages/edit']").attr("target", "_blank");
	jQuery('body').find('a.external-link, a.external, .external-link a, .best-prices__list__item__link').each(function () {
		var $this = jQuery(this);
		$this.attr('target', '_blank');
		$this.attr('rel', 'nofollow');
	});
	jQuery("body").on("submit", "#Form_SendSubscribeForm", function (e) {

		$form = jQuery("#Form_SendSubscribeForm");
		$.post($form.attr("action") + "?ajax=1", $form.serialize(), function (response) {
			if (jQuery(".message", $form).length > 0) {
				jQuery(".message", $form).replaceWith(response);

			} else {
				$form.find("fieldset").replaceWith(response);
			}

			//jQuery("a[rel='colorbox']").colorbox.resize()
			$form.find("input[type=text]").val("");
		}, 'html');

		return false;
	});

	//fix cmspreview links
	function CheckIfInPreview() {
		var field = 'CMSPreview';
		var url = window.location.href;
		if (url.indexOf('?' + field + '=') != -1)
			return true;
		else if (url.indexOf('&' + field + '=') != -1)
			return true;
		return false
	}

	if (CheckIfInPreview()) {
		$("a:not(.external)").each(function () {
			if ($(this).attr("href")) {
				var hashIndex = $(this).attr("href").indexOf("#");
				if (hashIndex > 0) {
					var href = $(this).attr("href");
					var hrefArray = $(this).attr("href").split("#");
					$(this).attr("href", hrefArray[0] + "?Locale=" + $("html").attr("lang").replace("-", "_") +"#"+ hrefArray[1]);
				} else {
					$(this).attr("href", $(this).attr("href") + "?Locale=" + $("html").attr("lang").replace("-", "_"));
				}
			}
		});
	}

};
theme.initCookieNotice = function () {

	/* JS cookie helper from https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie */
	var docCookies = {
		getItem: function (sKey) {
			if (!sKey) {
				return null;
			}
			return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
		},
		setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
			if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
				return false;
			}
			var sExpires = "";
			if (vEnd) {
				switch (vEnd.constructor) {
					case Number:
						sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
						break;
					case String:
						sExpires = "; expires=" + vEnd;
						break;
					case Date:
						sExpires = "; expires=" + vEnd.toUTCString();
						break;
				}
			}
			document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
			return true;
		},
		removeItem: function (sKey, sPath, sDomain) {
			if (!this.hasItem(sKey)) {
				return false;
			}
			document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
			return true;
		},
		hasItem: function (sKey) {
			if (!sKey) {
				return false;
			}
			return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
		},
		keys: function () {
			var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
			for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
				aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
			}
			return aKeys;
		}
	};
	/* End JS Cookie helper */

	/* Begin show/hide logic */
	if (!docCookies.hasItem('acceptedCookiePolicy')) {

		jQuery('.cookie-notice').css('display', 'block');

	}

	jQuery(document).on('click', '.cookie-accept', function (e) {

		e.preventDefault();

		docCookies.setItem('acceptedCookiePolicy', 'true', 5259487); // 2 months

		jQuery('.cookie-notice').css('display', 'none');

	});

};
(function ($) {
	/*theme.initParallax();
	$(window).scroll(function (e) {
		theme.doParallax();
	});*/
	theme.initFramework();
	theme.initVouchers();
	theme.initMobileHeader();
	theme.initLiveSearch();
	theme.initNavigation();
	theme.initShowMoreButton();
	theme.initAjaxSliders(".product-images-slider");
	theme.initFixedProductHeaders();
	theme.initReadMore();
	theme.initCookieNotice();
	setTimeout(theme.initGAGoals,200);
	$(window).on("orientationchange", function () {
		theme.initReadMore();
		//theme.initParallax();
		$(".product-images-slider .royalSlider").each(function () {
			var slider = $(this).data("royalslider");
			if (slider) {
				slider.updateSliderSize();
			}

		});
		console.log("orientation change !");
		//theme.initNavigation();
		//theme.initParallax();
	});
}(jQuery));